import React, { useState, useMemo, useEffect } from "react";
import { Layout as SideBar, Menu, Dropdown, Avatar, message } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  SettingOutlined,
  InteractionOutlined,
  FundOutlined,
  NumberOutlined,
  CalculatorOutlined,
  RadarChartOutlined,
  SwapOutlined,
  AlertFilled,
} from "@ant-design/icons";
import { useLocation, Link, Outlet, useNavigate } from "react-router-dom";
import MenuItems from "../SidebarItems";
import { useDispatch, useSelector } from "react-redux";
import "./layout.css";
import useWindowWidth from "../common/CommonFun";
import AuthService from "../auth/AuthService";
import AppLogo from "../../assets/images/PrefectosLogos.png";
import AppIcon from "../../assets/images/AppIcon.png";
import moment from "moment";
import Loading from "../loading/Loading";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { persistor } from "../../store";
import { AuditOutlined, BoxPlotOutlined, BranchesOutlined, ClockCircleOutlined, CloudUploadOutlined, DashboardOutlined, DatabaseFilled, ProductFilled, SnippetsFilled, StockOutlined, TableOutlined, UserOutlined } from '@ant-design/icons';
import { LocationCity } from '@mui/icons-material';
import { styled } from "@mui/system";
import { showMessage } from "../Utils/message";
import { initSocket, registerAisleAddedCallback, registerLocationAddedCallback, registerProductCallback, setupSocketListeners, socket } from "../Utils/socket";
import { RolePermissions } from "../common/Constants";
import dayjs from "dayjs";
import { Container } from "lucide-react";
const Auth = new AuthService();

const { Header, Content, Sider, Footer } = SideBar;

const DataSheet = styled('div')`
  
   .ant-input[disabled] {
      background: rgb(240, 240, 240);
      color: black;
    };
   .ant-menu-dark.ant-menu-inline .ant-menu-item  {
      padding-left: 30px !important;
    };
    .ant-layout-sider-collapsed {
    max-width: 65px !important;
    min-width: 65px !important;
    width: 65px !important
    };
`;

const AppLayout = () => {
  let layoutDispatch = useLoadingDispatch();

  const { activeTab } = useSelector((state) => state.UIState);
  const {  locationFetchedTime, lastFetchedTime, aisleFetchedTime } = useSelector((state) => state?.AppState?.userCreds);
  const { type, roles } = useSelector((state) => state.AppState.userCreds);
  
  const currWidth = useWindowWidth();

  const [currTab, setCurrTab] = useState(activeTab);
  const [collapsed, setCollapsed] = useState(currWidth <= 780);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasRole5 = roles?.some(r => r.role_id === 5);

  const Managername = localStorage.getItem("logged_in_user_name");
  const userObj = localStorage.getItem('helper');
  const helper = userObj  ? JSON.parse(userObj) : '';
  const name = type == 2 && hasRole5  ? helper?.first_name : Managername
  

  const MenuItems = [
    
    {
      label: "Dashboard",
      key: "/dashboard",
      path: "/dashboard",
      filterPath: '/dashboard',
      onClick: () => handleMenuItemClick("/dashboard"),
      icon: <DashboardOutlined/>,
      children: null,
    },
    {
      label: "Stocks",
      key: "/stocks",
      path: "/stocks",
      filterPath: '/stocks',
      onClick: () => handleMenuItemClick("/stocks"),
      icon: <StockOutlined/>,
      children: null,
    },
    {
      label: "Migrations",
      key: "/migrations",
      path: "/migrations",
      filterPath: '/migrations',
      onClick: () => handleMenuItemClick("/migrations"),
      icon: <CloudUploadOutlined/>,
      children: null,
    },   
    {
      label: "Operations",
       key: "/warehouse_manager",
       icon: <SettingOutlined />,
       children: [
        
        {
          label: "Rosters",
          key: "/rosters",
          onClick: () => handleMenuItemClick("/rosters"),
          icon: <BoxPlotOutlined/>,
        },
        {
          label: "Helpers",
          key: "/helpers",
          onClick: () => handleMenuItemClick("/helpers"),
          icon: <UserOutlined/>,
        },
        {
          label: "Reminders",
          key: "/helper_reminder",
          onClick: () => handleMenuItemClick("/helper_reminder"),
          icon: <ClockCircleOutlined/>,
        },
        {
          label: "Aisles",
          key: "/aisles",
          onClick: () => handleMenuItemClick("/aisles"),
          icon: <LocationCity/>,
        },
        {
          label: "Locations",
          key: "/locations",
          onClick: () => handleMenuItemClick("/locations"),
          icon: <TableOutlined/>,
        },
        {
          label: "Products",
          key: "/products", 
          onClick: () => handleMenuItemClick("/products"),
          icon: <DatabaseFilled/>,
        },
        {
          label: "Picking Locations",
          key: "/product-locations",
          onClick: () => handleMenuItemClick("/product-locations"),
          icon: <RadarChartOutlined />,
        },
        {
          label: "Cycle Counts",
          key: "/cycle-counts",
          onClick: () => handleMenuItemClick("/cycle-counts"),
          icon: <NumberOutlined />, 
        },
        // {
        //   label: "Alerts",
        //   key: "/alerts",
        //   onClick: () => handleMenuItemClick("/alerts"),
        //   icon: <AlertFilled />, 
        // },
       ]
    },
    {
      label: "Transactions",
       key: "/transactions",
       icon: <FundOutlined />,
       children: [
        {
          label: "Purchase Orders",
          key: "/transaction-po",
          onClick: () => handleMenuItemClick("/transaction-po"),
          icon: <FundOutlined/>,
        },
        {
          label: "Sale Invoices",
          key: "/transaction-so",
          onClick: () => handleMenuItemClick("/transaction-so"),
          icon: <BoxPlotOutlined/>,
        },
       
        {
          label: "Credit Notes",
          key: "/transaction-cn",
          onClick: () => handleMenuItemClick("/transaction-cn"),
          icon: <ClockCircleOutlined/>,
        },
        {
          label: "Opening Balances",
          key: "/transaction-ob",
          onClick: () => handleMenuItemClick("/transaction-ob"),
          icon: <LocationCity/>,
        },
        {
          label: "Inv. Adjustments",
          key: "/transaction-inventory",
          onClick: () => handleMenuItemClick("/transaction-inventory"),
          icon: <DatabaseFilled/>,
        },
        {
          label: "Transfer Stocks",
          key: "/transaction-transfer",
          onClick: () => handleMenuItemClick("/transaction-transfer"),
          icon: <SwapOutlined />,
        },
       ]
    }, 
    {
      label: "Reports",
       key: "/reports",
       icon: <CalculatorOutlined />,
       children: [
        {
          label: "Stock Trail",
          key: "/reports-stock-trail",
          onClick: () => handleMenuItemClick("/reports-stock-trail"),
          icon: <StockOutlined />,
        },
        {
          label: "Batch Expiry",
          key: "/reports-batches",
          onClick: () => handleMenuItemClick("/reports-batches"),
          icon: <Container size={18} />,
          
        },
       
       ]
    }, 
  ];
const allowedPaths = useMemo(() => {
  if (type === 0 || type === 1) return null; // full access
  const roleIds = roles?.map(r => r.role_id);
  const allowed = new Set();
  roleIds?.forEach(id => {
    RolePermissions[id]?.forEach(path => allowed.add(path));
  });
  return allowed;
}, [roles, type]);

const isPathAllowed = (path) => {
  if (type === 0 || type === 1) return true;
  return allowedPaths?.has(path);
};

const filteredMenuItems = MenuItems.filter(item => {
  if (!item.children) return isPathAllowed(item.path);
  const filteredChildren = item.children.filter(child => isPathAllowed(child.key));
  return filteredChildren.length > 0;
}).map(item => {
  if (!item.children) return item;
  const children = item.children.filter(child => isPathAllowed(child.key));
  return { ...item, children };
});


  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
      const hasRole5 = roles?.some(r => r.role_id === 5);

      if ((type === 2 && hasRole5)) {
        localStorage.removeItem("access_pin");
        navigate('/pin')
        
      } else {
      persistor.purge();
      navigate('/')
      localStorage.removeItem("id_token");
      dispatch({ type: "RESET_STATE" });
    }
  };

// useEffect(() => {
//   const loginTime = localStorage.getItem("pin_login_time");
//   const hasRole5 = roles?.some(r => r.role_id === 5);

//   const needsPin =
//     (type === 2 && hasRole5);
//   // Only apply PIN logic for type > 1
//   if (needsPin) {
//     if (loginTime) {
//       const minutesPassed = dayjs().diff(dayjs(Number(loginTime)), "minute");

//       if (minutesPassed >= 1) {
//         localStorage.removeItem("access_pin");
//         localStorage.removeItem("pin_login_time");
//         localStorage.removeItem("helper");
//         navigate("/pin");
//       }
//     } else {
//       // No login time for a PIN-required user
//       localStorage.removeItem("access_pin");
//       localStorage.removeItem("pin_login_time");
//       localStorage.removeItem("helper");
//       navigate("/pin");
//     }
//   }
// }, [activeTab]);

useEffect(() => {
  const checkPinExpiry = () => {
    console.log('running ....');
    
    const loginTime = localStorage.getItem("pin_login_time");
    const hasRole5 = roles?.some(r => r.role_id === 5);

    const needsPin = type === 2 && hasRole5;

    if (needsPin) {
      if (loginTime) {
        const minutesPassed = dayjs().diff(dayjs(Number(loginTime)), "minute");

        if (minutesPassed >= 20) {
          localStorage.removeItem("access_pin");
          localStorage.removeItem("pin_login_time");
          localStorage.removeItem("helper");
          navigate("/pin");
        }
      } else {
        // No login time for a PIN-required user
        localStorage.removeItem("access_pin");
        localStorage.removeItem("pin_login_time");
        localStorage.removeItem("helper");
        navigate("/pin");
      }
    }
  };

  // Run immediately on mount
  checkPinExpiry();

  // Then run every 30 seconds
  const interval = setInterval(checkPinExpiry, 10 * 1000);

  return () => clearInterval(interval); // cleanup when unmount
}, [roles, type]);



useEffect(() => {
    if (!socket.connected) {
      socket.connect();
      setupSocketListeners();
    }

    registerAisleAddedCallback(()=> {
      getAllAisles(true)
    });

    registerLocationAddedCallback(()=> {
      getAllLocs(true)
    });

    registerProductCallback(()=> {
      getAllPro(true)
      getAllLocs(true)
    });

    return () => {
      socket.disconnect(); 
      registerAisleAddedCallback(null);
    };
  }, []);


  const getAllAisles = async (force = false) => {

    showLoading(layoutDispatch)
    try {
      const currentTime = new Date().getTime();
      if (!force && aisleFetchedTime && currentTime - aisleFetchedTime < 60 * 60 * 1000 * 24) {
        console.log('cached aisles');
        return;
      }
      console.log("🌐 Fetching aisles from server...")
      const res = await Auth.fetch(`/aisle/aisles`);
      if (res.ack) {
        if (res?.aisles.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_AISLE',
            payload: { aisles: res?.aisles, timestamp: newTimestamp },
          });
        }
      } else {
        showMessage("error", res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage("error", "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getAllLocs = async (force = false) => {
    showLoading(layoutDispatch)
    try {
      const currentTime = new Date().getTime();
      if (!force && locationFetchedTime && currentTime - locationFetchedTime < 60 * 60 * 1000 * 24) {
        console.log('cached locations');
        return;
      }
      const res = await Auth.fetch(`/location/locations`);
      if (res.ack) {
        // setAllLocations(res?.locations)
        if (res?.locations.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_LOCATIONS',
            payload: { locations: res?.locations, timestamp: newTimestamp },
          });
        }
      } else {
        showMessage("error", res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage("error", "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getAllPro = async (force = false) => {
    showLoading(layoutDispatch)
    try {
      const currentTime = new Date().getTime();
      if (!force &&lastFetchedTime && currentTime - lastFetchedTime < 30 * 60 * 1000) {
        console.log('cached products');
        return;
      }
      const res = await Auth.fetch(`/product/products`);
      if (res.ack) {
        if (res?.products.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_PRODUCTS',
            payload: { products: res?.products, timestamp: newTimestamp },
          });
        }

        // setProducts(res?.products)
        
      } else {
        showMessage("error", res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage("error", "Something went wrong while fetching products.");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  useEffect(() => {
    getAllLocs();
    getAllPro();
    getAllAisles()
  }, [activeTab])


  useMemo(() => {
    dispatch({ type: "SET_ACTIVE_TAB", payload: location.pathname });
    setCurrTab(activeTab);
  }, [location, dispatch, activeTab]);

  const removeExtraSlashDataFromRoute = (route) => {
    const routeArray = route?.split("/");
    const newRouteArray = routeArray?.filter((item) => item !== "");
    return "/" + newRouteArray?.[0]?.toString();
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="sign-out"
        onClick={handleLogout}
        icon={<LogoutOutlined />}
      >
        Sign Out
      </Menu.Item>
    </Menu>
  );

  const handleMenuItemClick = (path) => {
    navigate(path);
  };

  

  return (
    <DataSheet>
    <SideBar style={{ height: "100vh" }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo-container">
          {!collapsed ? (
            <img style={{ height: "32px" }} src={AppLogo} alt="appLogo" />
          ) : (
            <img style={{ height: "32px" }} src={AppIcon} alt="appIcon" />
          )}

        </div>
        {/* <Menu theme="dark" mode="inline" selectedKeys={removeExtraSlashDataFromRoute(currTab)}>
          {MenuItems?.map((item) => {
            return (
              <Menu.Item key={item.path} icon={item.icon}>
                <Link to={item.path}>{item.name}</Link>
              </Menu.Item>
            );
          })}
        </Menu> */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={removeExtraSlashDataFromRoute(currTab)}
          // defaultOpenKeys={defaultOpenKeys}
        >
          {filteredMenuItems.map((item) =>
            Array.isArray(item.children) ? (
              <Menu.SubMenu key={item.key} icon={item.icon} title={item.label}>
                {item.children.map((child) => (
                  <Menu.Item
                    key={child.key}
                    icon={child.icon}
                    // onClick={() => handleMenuItemClick(child.key)}
                  >
                    <Link className="no-underline" key={child.key} to={child.key}>
                            {child.label}
                          </Link>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            ) : (
              <Menu.Item
                key={item.key}
                icon={item.icon}
                // onClick={() => handleMenuItemClick(item.key)}
              >
                <Link className="no-underline" key={item.key} to={item.key}>
                            {item.label}
                          </Link>
              </Menu.Item>
            )
          )}
        </Menu>
      </Sider>
      <SideBar style={{ padding: "0" }}>
        <Header style={{ padding: "0", background: "white", borderBottom: '1px solid lightBlue' }}>
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className=" header-container"
          >
            <div>
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: toggle,
                }
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <>{name && (

                <>
                  {currWidth >= 960 && (
                    <span className="light-span">
                      Hello,{" "}
                      <strong className="user-name">{name ? name : ""}</strong>
                    </span>
                  )}
                  <Dropdown overlay={menu} arrow>
                    <Avatar className="avatar-extra" size="large">
                      {name?.charAt(0).toUpperCase()}
                    </Avatar>
                  </Dropdown>
                </>
              )
              }
              </>

            </div>
          </div>
        </Header>
        <div className="content-wrapper">
          <Content style={{ background: "white" }} className="context-box">
            <Outlet />
          </Content>
        </div>
        <Footer style={{ display: "flex", justifyContent: "center", padding: '5px 5px' }}>

          Prefectos ©{new Date().getFullYear()}
        </Footer>
      </SideBar>
      <Loading />
    </SideBar>
    </DataSheet>
  );
};

export default AppLayout;
